// @flow
import styled from "styled-components";
import { mediumParagraph } from "@nested/brand";

export const QuestionDescription = styled.p`
  ${mediumParagraph}
  margin: 30px 0;
`;
